import React from 'react'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import './BuildingAndProperty.scss'

//Components
import PropertyAccess from './PropertyAccess'
import WaterSupply from './WaterSupply'
import BuildingInformation from './BuildingInformation'
import Utilities from './Utilities'
import Roofing from './Roofing'
import HazardousMaterials from './HazardousMaterials'

const BuildingAndProperty = React.memo(({ buildingAndPropertyEntity }) => {
  const buildingAndProperty = React.useMemo(
    () => ({ ...buildingAndPropertyEntity }),
    [buildingAndPropertyEntity]
  )

  return (
    <div className="building-and-property">
      <h2>Building and property</h2>
      <div className="building-and-property-section">
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid size={12}></Grid>
            <Grid size={12}>
              <form noValidate autoComplete="off">
                <Grid container>
                  <Grid size={12} className="container-field">
                    {buildingAndProperty.propertyAccess &&
                    buildingAndProperty.propertyAccess !== null ? (
                      <PropertyAccess propertyAccessEntity={buildingAndProperty.propertyAccess} />
                    ) : null}
                    {buildingAndProperty.fireAlarmSystem &&
                    buildingAndProperty.fireAlarmSystem.isChecked !== null &&
                    buildingAndProperty.fireAlarmSystem.isChecked ? (
                      <>
                        <h2 className="section-title">Alarm System</h2>
                        <Grid className="section">
                          <label className="main-title-label">
                            <span className="answer">
                              Yes
                              {buildingAndProperty.fireAlarmSystem.isChecked ? (
                                <>
                                  {buildingAndProperty.fireAlarmSystem.isChecked &&
                                  buildingAndProperty.fireAlarmSystem.location !== null &&
                                  buildingAndProperty.fireAlarmSystem.location !== '' ? (
                                    <>{`, Location: ${buildingAndProperty.fireAlarmSystem.location}`}</>
                                  ) : null}
                                </>
                              ) : (
                                ''
                              )}
                            </span>
                          </label>
                        </Grid>
                      </>
                    ) : null}

                    {buildingAndProperty.waterSupply && buildingAndProperty.waterSupply !== null ? (
                      <WaterSupply waterSupplyEntity={buildingAndProperty.waterSupply} />
                    ) : (
                      <></>
                    )}

                    {buildingAndProperty.buildingInformation &&
                    buildingAndProperty.buildingInformation !== null ? (
                      <BuildingInformation
                        buildingInformationEntity={buildingAndProperty.buildingInformation}
                      />
                    ) : (
                      <></>
                    )}

                    {buildingAndProperty.utilities && buildingAndProperty.utilities !== null ? (
                      <Utilities utilitiesEntity={buildingAndProperty.utilities} />
                    ) : (
                      <></>
                    )}

                    {buildingAndProperty.roofing && buildingAndProperty.roofing !== null ? (
                      <Roofing roofingEntity={buildingAndProperty.roofing} />
                    ) : (
                      <></>
                    )}

                    {buildingAndProperty.hazardousMaterials &&
                    buildingAndProperty.hazardousMaterials !== null ? (
                      <HazardousMaterials
                        hazardousMaterialsEntity={buildingAndProperty.hazardousMaterials}
                      />
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  )
})

export default BuildingAndProperty
